import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Paper,
  Table,
  TableBody,
} from '@material-ui/core';

import i18n from '../../i18n';

import EcommTableHeader from './EcommTableHeader';
import EcommTableFooter from './EcommTableFooter';
import EcommDataCheckboxRow from './EcommDataCheckboxRow';
import { LocationType } from '../../validation';
import EcommDataDateAndNameRow from './EcommDataDateAndNameRow';
import EcommDoubleBookingRows from './EcommDoubleBookingRows';
import EcommDataProductTierRow from './EcommDataProductTierRow';
import EcommDataSpecialProjectRow from './EcommDataSpecialProjectRow';
import { ecommTableNumericRows, ecommTableDropdownRows } from '../../constants/ecommDataTableRowLabelAndValueKey';
import { dropdownRowMap, numberRowMap } from '../../helpers/ecommTableHelpers';

import { shouldDisplayIsWeekend } from '../../helpers/helpers';

import 'react-datepicker/dist/react-datepicker.css';

class EcommDataPrepTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prepData: {
        ...props.prepData
      }
    };
  }

  handleChange = (event, key) => {
    event.persist();
    const { name, value } = event.target;
    this.saveChange(name, value, key);
  }

  saveChange = (name, value, key) => {
    const keyValues = { [name]: value };
    const { saveOne } = this.props;
    this.setState(prevState => ({
      prepData: {
        ...prevState.prepData,
        [key]: {
          ...prevState.prepData[key],
          [name]: value
        }
      }
    }));
    if (value || value === 0) {
      const { prepData } = this.state;
      saveOne({
        date: prepData[key].date,
        locationType: 'prep',
        locationId: prepData[key].locationId,
        isWeekendPrep: prepData[key].isWeekendPrep,
        keyValues,
        updatedAt: new Date().getTime() / 1000
      });
    }
  };

  handleSpecialProjectChange = (event, key) => {
    event.persist();
    const { name, value } = event.target;
    const { saveOne } = this.props;
    // value === -1 is 'None'
    const isSpecialProject = value !== -1;
    const projectName = isSpecialProject ? value : null;
    const keyValues = { [name]: projectName, isSpecialProject };
    this.setState(prevState => ({
      prepData: {
        ...prevState.prepData,
        [key]: {
          ...prevState.prepData[key],
          [name]: projectName,
          isSpecialProject,
        }
      }
    }),
    () => {
      const { prepData } = this.state;
      saveOne({
        date: prepData[key].date,
        locationType: 'prep',
        locationId: prepData[key].locationId,
        isWeekendPrep: prepData[key].isWeekendPrep,
        keyValues,
        updatedAt: new Date().getTime() / 1000
      });
    });
  };

  handlePilotCheckbox = (event, key) => {
    const { checked } = event.currentTarget;
    const keyValues = { isPilot: checked };
    const { saveOne } = this.props;
    this.setState(
      prevState => ({
        prepData: {
          ...prevState.prepData,
          [key]: {
            ...prevState.prepData[key],
            isPilot: checked
          }
        }
      }),
      () => {
        const { prepData } = this.state;
        saveOne({
          date: prepData[key].date,
          locationType: 'prep',
          locationId: prepData[key].locationId,
          isWeekendPrep: prepData[key].isWeekendPrep,
          keyValues,
          updatedAt: new Date().getTime() / 1000
        })
      }
    );
  };

  handleIsWeekendPrepCheckbox = (event, key) => {
    const { checked } = event.currentTarget;
    const keyValues = { isWeekendPrep: checked };
    const { saveOne } = this.props;
    this.setState(prevState => ({
      prepData: {
        ...prevState.prepData,
        [key]: {
          ...prevState.prepData[key],
          isWeekendPrep: checked
        }
      }
    }),
    () => {
      const { prepData } = this.state;
      saveOne({
        date: prepData[key].date,
        locationType: 'prep',
        locationId: prepData[key].locationId,
        isWeekendPrep: prepData[key].isWeekendPrep,
        keyValues,
        updatedAt: new Date().getTime() / 1000
      })
    })
  }

  handleDoubleStylistCheckbox = (event, key) => {
    const { checked } = event.currentTarget;
    const keyValues = { isDoubleStylist: checked };
    const { saveOne } = this.props;
    this.setState(
      prevState => ({
        prepData: {
          ...prevState.prepData,
          [key]: {
            ...prevState.prepData[key],
            isDoubleStylist: checked
          }
        }
      }),
      () => {
        const { prepData } = this.state;
        saveOne({
          date: prepData[key].date,
          locationType: 'prep',
          locationId: prepData[key].locationId,
          isWeekendPrep: prepData[key].isWeekendPrep,
          keyValues,
          updatedAt: new Date().getTime() / 1000
        })
      }
    );
  };

  getTabIndex = (column)=>{
    const { startTabIndex } = this.props;
    return startTabIndex + column
  }

  render() {
    const { prepData } = this.state;
    const {
      handleDatePickerChange,
      date,
      fetchPrevious,
      fetchNext,
      getNow,
      specialProjectOptions,
      canEdit,
      locationType
    } = this.props;
    return (
      <Paper className="ecommForm">
        <Table>
          <EcommTableHeader
            headerKey="PrepTitle"
            tableTitle={i18n.t('location:prepTableTitle')}
          />
          <TableBody>
            <EcommDataDateAndNameRow
              date={date}
              fetchNext={fetchNext}
              fetchPrevious={fetchPrevious}
              handleDatePickerChange={handleDatePickerChange}
              locationNames={Object.keys(prepData).map(element =>
                prepData[element].prepName)}
            />
            {ecommTableDropdownRows.slice(2, 3).map(dropdownRowMap(canEdit, this.handleChange, this.getTabIndex, prepData))}
            {ecommTableNumericRows.slice(3, 7).map(numberRowMap(canEdit, this.handleChange, this.getTabIndex, prepData))}
            {ecommTableNumericRows.slice(7, 11).map(numberRowMap(canEdit, this.handleChange, this.getTabIndex, prepData))}
            {ecommTableDropdownRows.slice(0, 1).map(dropdownRowMap(canEdit, this.handleChange, this.getTabIndex, prepData))}
            <EcommDataCheckboxRow 
              rowTitle={i18n.t('location:pilot').toUpperCase()}
              tableDataSet={prepData}
              disabled={!canEdit}
              checkboxKey="isPilot"
              rowClassName="studioDataRight"
              onChange={this.handlePilotCheckbox}
            />
            <EcommDoubleBookingRows 
              locationType={locationType}
              saveChange={this.saveChange}
              canEdit={canEdit}
              studioData={prepData}
              getTabIndex={this.getTabIndex}
            />
            <EcommDataSpecialProjectRow
              canEdit={canEdit}
              getTabIndex={this.getTabIndex}
              locationData={prepData}
              specialProjectOptions={specialProjectOptions}
              handleSpecialProjectChange={this.handleSpecialProjectChange}
            />
            <EcommDataProductTierRow
              canEdit={canEdit}
              getTabIndex={this.getTabIndex}
              locationData={prepData}
              handleChange={this.handleChange}
            />
            {shouldDisplayIsWeekend(prepData[0].date) && (
              <EcommDataCheckboxRow 
                rowTitle={i18n.t('location:isWeekendPrep').toUpperCase()}
                tableDataSet={prepData}
                disabled={!canEdit}
                checkboxKey="isWeekendPrep"
                rowClassName="studioDataRight"
                onChange={this.handleIsWeekendPrepCheckbox}
              />
            )}
          </TableBody>
          <EcommTableFooter getNow={getNow} />
        </Table>
      </Paper>
    );
  }
}

EcommDataPrepTable.propTypes = {
  prepData: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.string])
  ).isRequired,
  locationType: LocationType.isRequired,
  specialProjectOptions: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]).isRequired,
  saveOne: PropTypes.func.isRequired,
  getNow: PropTypes.func.isRequired,
  canEdit: PropTypes.bool.isRequired,
  handleDatePickerChange: PropTypes.func.isRequired,
  fetchPrevious: PropTypes.func.isRequired,
  fetchNext: PropTypes.func.isRequired,
  date: PropTypes.instanceOf(Date).isRequired,
  startTabIndex: PropTypes.number
};

EcommDataPrepTable.defaultProps = {
  startTabIndex: 1
}

export default EcommDataPrepTable;
